import React, { useEffect } from 'react';
import sdslogo from "../../assets/images/sdslogo.jpeg";
import lmxlogo from "../../assets/images/lmx.png";
import codebindlogo from "../../assets/images/codebind.png";

export default function Experience() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  useEffect(() => {
    scrollToTop()
  }, [])
  return (
    <div className="bg-gray-50 min-h-screen py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="relative border-l-4 border-gray-200 ml-4 md:ml-32">
          {experiences.map((exp, index) => (
            <div key={index} className="mb-16 ml-8 relative">
              {/* Timeline Marker */}
              <div className="absolute -left-[38px] top-0 w-8 h-8 bg-sky-500 rounded-full border-4 border-white shadow-lg z-10"></div>

              {/* Date Column (Hidden on mobile) */}
              <div className="hidden md:block absolute -left-40 top-1 w-24 text-right">
                <span className="text-sm font-bold text-gray-400 uppercase tracking-widest leading-tight">
                  {exp.date.split('–')[0]}
                  <br />
                  {exp.date.split('–')[1] || ''}
                </span>
              </div>

              <div className="group bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-sky-100 transform hover:-translate-y-1">
                <div className="flex flex-col md:flex-row gap-6 items-start">
                  <div
                    className="w-20 h-20 flex-shrink-0 bg-white rounded-xl shadow-inner border border-gray-100 p-2 flex items-center justify-center cursor-pointer overflow-hidden transform group-hover:scale-105 transition-transform"
                    // onClick={() => window.open(exp.companyUrl || window.location.href, '_blank')}
                  >
                    <img
                      className="max-h-full max-w-full object-contain"
                      src={exp.img}
                      alt={exp.company}
                    />
                  </div>

                  <div className="flex-grow">
                    <div className="flex justify-between items-start mb-2">
                      <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight">
                        {exp.position}
                      </h3>
                    </div>
                    <div className="text-sky-600 font-bold text-lg mb-4 flex items-center">
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 11-2 0V4H6v12a1 1 0 11-2 0V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                      </svg>
                      {exp.company}
                    </div>

                    <div className="md:hidden mb-4 text-sm font-bold text-gray-400 uppercase tracking-widest">
                      {exp.date}
                    </div>

                    <ul className="space-y-3">
                      {exp.details.map((detail, idx) => (
                        <li key={idx} className="flex items-start text-gray-600 leading-relaxed font-medium">
                          <span className="text-sky-400 mr-2 mt-1.5">•</span>
                          {detail}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
const experiences = [
  {
    position: 'Senior Full Stack Developer',
    company: 'Shining Dawn solutions, Coimbatore',
    details: [
      'Collaborating in a team of four to develop a feature-rich CRM and retail software tailored for jewellery shops, streamlining operations across billing, schemes, and inventory tracking.',
      'Implementing modules for managing chits, bills, scheme accounts, karigar (artisan) records, stones, tags, and lot-tracking, ensuring complete operational visibility.',
      'Developing a robust Django backend integrated with a MySQL database, ensuring secure and scalable handling of customer and transaction data.',
      'Coordinating effectively within the team to achieve milestones, maintain code quality, and ensure timely delivery of project features.',
      'Developed Flutter mobile apps to automate business processes and improve accessibility.'
    ],
    date: 'May, 2024 – Present',
    img: sdslogo,
    companyUrl: "#"
  },
  {
    position: 'Junior Programmer',
    company: 'Logimax Technologies Pvt. Ltd, Coimbatore',
    details: [
      'Designed and developed a user-friendly payroll management system using ReactJS with Reactstrap, enabling automated calculation of salaries, deductions, and tax compliance.',
      'Maintained the entire Django backend and MySQL schema to handle employee records, payroll details, and transaction histories seamlessly, ensuring high performance, scalability, and secure handling of sensitive payroll data.',
      'Designed and developed a responsive, feature-rich e-commerce platform using React and Tailwind CSS, offering seamless shopping experiences with functionalities like wishlist, cart, order tracking, and user profile management across all devices.'
    ],
    date: 'Feb 2023 – May 2024',
    img: lmxlogo,
    // companyUrl: "https://www.logimaxindia.com/"
  },
  {
    position: 'Intern',
    company: 'Code Bind Technologies, Chennai.',
    details: [
      'Hands on training on scripting languages like HTML, CSS, PHP and MySQL.'
    ],
    date: 'Aug 2021 - Sept 2021',
    img: codebindlogo,
    // companyUrl: "https://codebindtechnologies.com/"
  },
];